import { useQuery, useMutation, useQueryClient } from 'react-query';
import {
    MarkNotificationRead,
    MarkAllNotificationsRead,
    GetUserNotifications,
} from '../services/backend';
import { Notify, NotifyError } from '../utils/functions';

export function useGetUserNotifications() {
    return useQuery('user-notifications', () => GetUserNotifications(), {
        refetchOnWindowFocus: true, // Fetch when user returns to the app/tab
        staleTime: 30 * 1000, // 30 seconds - keeps it from spamming if they rapidly switch tabs
        select: (data) => {
            return data?.data || [];
        },
        onError: (error) => {
            NotifyError("Failed to fetch user notifications", error);
            console.error("Error fetching user notifications:", error);
        }
    });
}

export function useMarkNotificationRead() {
    const queryClient = useQueryClient();
    return useMutation(({ notificationId, showToast = false }) => MarkNotificationRead(notificationId), {
        onSuccess: (data, variables) => {
            queryClient.invalidateQueries('user-notifications');
            if (variables.showToast) {
                Notify("Notification marked as read", "success");
            }
        },
        onError: (error, variables) => {
            if (variables.showToast !== false) {
                NotifyError("Failed to mark notification as read", error);
            }
            console.error("Error marking notification as read:", error);
        }
    });
}

export function useMarkAllNotificationsRead() {
    const queryClient = useQueryClient();
    return useMutation(() => MarkAllNotificationsRead(), {
        onSuccess: () => {
            queryClient.invalidateQueries('user-notifications');
            Notify("All notifications marked as read", "success");
        },
        onError: (error) => {
            NotifyError("Failed to mark all notifications as read", error);
            console.error("Error marking all notifications as read:", error);
        }
    });
}